<div class="flex flex-col overflow-x-hidden w-screen p-1 lg:pl-22 lg:pr-4">
    <!-- Loading State -->
    <div *ngIf="loading"
        class="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex items-center justify-center">
        <div class="text-white text-xl">Chargement...</div>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading"
        class="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex items-center justify-center">
        <div class="text-red-500 text-xl">Erreur lors du chargement de l'équipe</div>
    </div>

    <!-- Main Content -->
    <div *ngIf="!loading && !error && team"
        class="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
        <!-- DESKTOP VERSION - Hidden on mobile -->
        <div class="hidden lg:block">
            <!-- Header Section with Background Image -->
            <div class="relative bg-cover bg-center bg-no-repeat h-[500px] md:h-[600px]"
                [ngStyle]="{'background-image': team.teamInfo.banner_url ? 'url(' + team.teamInfo.banner_url + ')' : 'url(assets/images/team/bck1.jpg)'}">
                <div class="absolute inset-0 bg-black opacity-60"></div>

                <!-- Main Header Content -->
                <div class="relative z-10 h-full flex flex-col">
                    <!-- Top Section: Team Info Left + Title Center -->
                    <div class="flex-1 flex items-center justify-between px-6 py-8">
                        <!-- Center Title -->
                        <div
                            class="absolute left-1/2 top-[45%] transform -translate-x-1/2 -translate-y-1/2 text-center">
                            <h1
                                class="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight drop-shadow-2xl">
                                {{ team.teamInfo.name || '' }}
                            </h1>
                            <p class="text-lg md:text-xl lg:text-2xl text-gray-200 font-semibold mt-2 drop-shadow-lg">
                                {{ team.teamInfo.description || 'Équipe U16' }}
                            </p>
                        </div>
                    </div>

                    <!-- Bottom Section: Contact and Horizontal Scrollable Events -->
                    <div class="flex items-stretch justify-between px-6 pb-6">
                        <!-- Cas 1 : Quand il y a des matchs à venir -->
                        <ng-container *ngIf="upcomingEvents?.length > 0">
                            <!-- Contact Section (Left) -->
                            <div
                                class="flex h-[200px] bg-gray-900 bg-opacity-80 rounded-xl p-6 backdrop-blur-sm border border-gray-700 flex-col justify-between">
                                <div class="flex items-center space-x-4">
                                    <!-- Team Logo -->
                                    <div class="w-32 h-32 rounded-full overflow-hidden flex-shrink-0">
                                        <app-logo></app-logo>
                                    </div>
                                    <!-- Team Contact Details -->
                                    <div class="space-y-1 pl-4 text-base">
                                        <div class="text-gray-300">
                                            <p>CONTACT: <span class="text-primary-400 text-base">{{ team.teamInfo.email
                                                    || 'info@ecoclubsports.com' }}</span></p>
                                        </div>
                                        <div class="flex items-center space-x-2 text-gray-300 text-base">
                                            <!-- Icône téléphone -->
                                            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path
                                                    d="M2.003 5.884l.94-2.828A1 1 0 013.89 2h2.517a1 1 0 01.949.684l1.077 3.23a1 1 0 01-.21.987L6.71 8.84a11.042 11.042 0 005.44 5.44l1.94-1.413a1 1 0 01.987-.21l3.23 1.077a1 1 0 01.684.949v2.517a1 1 0 01-.73.957l-2.828.94a2 2 0 01-1.848-.267 17.013 17.013 0 01-7.592-7.592 2 2 0 01-.267-1.848z" />
                                            </svg>
                                            <span>{{ team.teamInfo.phone || '+33 000 00000' }}</span>
                                        </div>
                                        <div class="flex items-center space-x-2 text-gray-300 text-base">
                                            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span>{{ team.teamInfo.location || 'Paris, France' }}</span>
                                        </div>
                                        <div class="flex items-center space-x-2 text-gray-300 text-base">
                                            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span>Saison {{ team.teamInfo.season || '2024-2025' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Horizontal Scrollable Events (Right) -->
                            <div class="flex-[2] pl-4 overflow-x-auto">
                                <div class="flex space-x-4 pb-4 min-w-max">
                                    <!-- Championship Event Cards -->
                                    <div class="flex-shrink-0 bg-primary-400 rounded-xl p-4 text-black min-w-[280px] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                                        *ngFor="let match of upcomingEvents">
                                        <div class="text-center">
                                            <h3 class="font-bold mb-2 text-xl italic uppercase">{{
                                                getEventTypeLabel(match.type) }}</h3>
                                            <!-- Home/Away Indicator for non-training/event -->
                                            <p *ngIf="match.type !== 'ENTRAINEMENT' && match.type !== 'EVENEMENT'"
                                                class="text-sm text-gray-800 font-semibold mb-2">
                                                {{ match.isHome ? 'Domicile' : 'Extérieur' }}
                                            </p>
                                            <!-- Teams vs Section -->
                                            <div class="flex items-center justify-between mb-4">
                                                <ng-container
                                                    *ngIf="match.type === 'ENTRAINEMENT' || match.type === 'EVENEMENT'; else matchVs">
                                                    <!-- Single Team Logo for Training/Event -->
                                                    <div class="flex flex-col items-center w-full">
                                                        <div
                                                            class="w-12 h-12 rounded-full bg-black flex items-center justify-center mb-2">
                                                            <img [src]="teamLogoUrl" alt="Team Logo"
                                                                class="w-full h-full object-contain">
                                                        </div>
                                                        <span class="text-xs font-semibold text-center leading-tight">
                                                            {{ team.teamInfo.name }}
                                                        </span>
                                                    </div>
                                                </ng-container>
                                                <ng-template #matchVs>
                                                    <!-- Home Team (Left) -->
                                                    <div class="flex flex-col items-center">
                                                        <div
                                                            class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                                            <img [src]="match.isHome ? teamLogoUrl : (match.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                                                alt="Home Team Logo"
                                                                class="w-full h-full object-contain">
                                                        </div>
                                                        <span class="text-xs font-semibold text-center leading-tight">
                                                            {{ match.homeTeam }}
                                                        </span>
                                                    </div>
                                                    <!-- VS -->
                                                    <div class="text-xl font-bold mx-3">VS</div>
                                                    <!-- Away Team (Right) -->
                                                    <div class="flex flex-col items-center">
                                                        <div
                                                            class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                                            <img [src]="match.isHome ? (match.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                                                alt="Away Team Logo"
                                                                class="w-full h-full object-contain">
                                                        </div>
                                                        <span class="text-xs font-semibold text-center leading-tight">
                                                            {{ match.awayTeam }}
                                                        </span>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <!-- Match Details -->
                                            <div class="space-y-1 text-sm">
                                                <div class="font-semibold">
                                                    {{ match.date | date:'EEEE, dd MMMM':'fr' }}
                                                </div>
                                                <div class="text-gray-700">
                                                    📍 {{ match.location || 'À définir' }}
                                                </div>

                                                @if(match.type !== 'ENTRAINEMENT' && match.type !== 'EVENEMENT') {
                                                <div class="flex w-full items-center justify-center my-2">
                                                    <button type="button" (touchstart)="onGoToMatchDetail(match.id)"(click)="onGoToMatchDetail(match.id)" mat-flat-button
                                                        color="primary">
                                                        {{ "ADVERTISING.view_details" | transloco }}
                                                    </button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Cas 2 : Quand il n'y a pas de matchs à venir -->
                        <ng-container *ngIf="!upcomingEvents || upcomingEvents.length === 0">
                            <div class="w-full flex justify-center">
                                <div
                                    class="flex h-[200px] bg-gray-900 bg-opacity-80 rounded-xl p-6 backdrop-blur-sm border border-gray-700 flex-col justify-between">
                                    <div class="flex items-center space-x-4">
                                        <!-- Team Logo -->
                                        <div class="w-32 h-32 rounded-full overflow-hidden flex-shrink-0">
                                            <app-logo></app-logo>
                                        </div>
                                        <!-- Team Contact Details -->
                                        <div class="space-y-1 pl-4 text-base">
                                            <div class="text-gray-300">
                                                <p>CONTACT: <span class="text-primary-400 text-base">{{
                                                        team.teamInfo.email || 'info@ecoclubsports.com' }}</span></p>
                                            </div>
                                            <div class="flex items-center space-x-2 text-gray-300 text-base">
                                                <!-- Icône téléphone -->
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M2.003 5.884l.94-2.828A1 1 0 013.89 2h2.517a1 1 0 01.949.684l1.077 3.23a1 1 0 01-.21.987L6.71 8.84a11.042 11.042 0 005.44 5.44l1.94-1.413a1 1 0 01.987-.21l3.23 1.077a1 1 0 01.684.949v2.517a1 1 0 01-.73.957l-2.828.94a2 2 0 01-1.848-.267 17.013 17.013 0 01-7.592-7.592 2 2 0 01-.267-1.848z" />
                                                </svg>
                                                <span>{{ team.teamInfo.phone || '+33 000 00000' }}</span>
                                            </div>
                                            <div class="flex items-center space-x-2 text-gray-300 text-base">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                <span>{{ team.teamInfo.location || 'Paris, France' }}</span>
                                            </div>
                                            <div class="flex items-center space-x-2 text-gray-300 text-base">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                <span>Saison {{ team.teamInfo.season || '2024-2025' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Desktop Content Grid -->
                <div class="container mx-auto px-6 pb-12 pt-8">
                    <div class="grid xl:grid-cols-2 gap-8">
                        <!-- Left Column -->
                        <div class="space-y-8">
                            <!-- Staff Section -->
                            <!-- Staff Section -->
                            <div
                                class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 relative overflow-hidden">
                                <h2 class="text-2xl font-bold mb-6 text-primary-400">STAFF TECHNIQUE</h2>
                                <div class="relative">
                                    <!-- Left Arrow -->
                                    <button (click)="previousCoach()"
                                        class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-primary-400 text-black rounded-full w-8 h-8 flex items-center justify-center hover:bg-primary-500 transition-colors"
                                        aria-label="Previous Coach">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15 19l-7-7 7-7" />
                                        </svg>
                                    </button>
                                    <!-- Coach Content -->
                                    <div class="flex items-center justify-between space-x-6 px-16">
                                        <div class="flex items-center space-x-6">
                                            <div class="relative">
                                                <div
                                                    class="w-20 h-20 bg-gradient-to-br from-primary-400 to-orange-500 rounded-full flex items-center justify-center text-black font-bold text-2xl shadow-lg">
                                                    {{ getPlayerInitials(getCurrentCoach().name) }}
                                                </div>
                                            </div>
                                            <div class="flex-1">
                                                <h3 class="text-2xl font-bold text-white mb-1">{{ getCurrentCoach().name
                                                    }}</h3>
                                                <p class="text-primary-400 font-medium mb-2">{{ getCurrentCoach().title
                                                    }}</p>
                                            </div>
                                        </div>
                                        <div class="hidden md:block">
                                            <img [src]="getCoachLogoUrl(getCurrentCoach())" alt="Coach Logo"
                                                class="w-60 h-48 object-contain" />
                                        </div>
                                    </div>
                                    <!-- Right Arrow -->
                                    <button (click)="nextCoach()"
                                        class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-primary-400 text-black rounded-full w-8 h-8 flex items-center justify-center hover:bg-primary-500 transition-colors"
                                        aria-label="Next Coach">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                    <!-- Dots for Coach Navigation -->
                                    <div class="flex justify-center space-x-2 mt-4">
                                        <div *ngFor="let coach of coaches; let i = index"
                                            class="w-2 h-2 rounded-full transition-all duration-300"
                                            [ngClass]="i === currentCoachIndex ? 'bg-primary-400' : 'bg-gray-500'"
                                            (click)="goToCoach(i)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- TERRAIN -->
                            <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                                <h2 class="text-2xl font-bold mb-4 text-primary-400">COMPOSITION</h2>

                                <div *ngIf="lastMatchWithLineup?.lineup; else defaultTerrain">
                                    <app-lineup [match]="lastMatchWithLineup"
                                        [lastValidLineup]="lastMatchWithLineup.lineup" [readOnlyMode]="true">
                                    </app-lineup>
                                </div>

                                <!-- Terrain par défaut sans joueurs -->
                                <ng-template #defaultTerrain>
                                    <app-lineup [match]="createEmptyMatch()" [readOnlyMode]="true">
                                    </app-lineup>
                                </ng-template>
                            </div>
                        </div>

                        <!-- Right Column -->
                        <div class="space-y-8">
                            <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                                <h2 class="text-2xl font-bold mb-4 text-primary-400">PROCHAIN MATCH</h2>
                                <div class="bg-black/30 rounded-lg p-6" *ngIf="upcomingMatch; else noMatch">
                                    <div class="text-center mb-4">
                                        <p class="text-gray-400 text-sm mb-2">{{ upcomingMatch.date | date:'EEEE, dd MMMM':'fr' }}</p>
                                        <div class="flex items-center justify-center mb-4">
                                            <ng-container
                                                *ngIf="upcomingMatch.type === 'ENTRAINEMENT' || upcomingMatch.type === 'EVENEMENT'; else matchVs">
                                                <!-- Single Team Logo for Training/Event -->
                                                <div class="flex flex-col items-center w-full">
                                                    <h3 class="font-bold mb-2 text-lg"
                                                        *ngIf="upcomingMatch.type === 'ENTRAINEMENT'">{{
                                                        getEventTypeLabel(upcomingMatch.type) }}</h3>

                                                    <div
                                                        class="w-16 h-16 rounded-full flex items-center justify-center mb-2">
                                                        <img [src]="teamLogoUrl" alt="Team Logo"
                                                            class="w-full h-full object-contain" />
                                                    </div>
                                                    <span class="text-sm font-semibold text-center">{{
                                                        team.teamInfo.name }}</span>
                                                </div>
                                            </ng-container>
                                            <ng-template #matchVs>
                                                <!-- Home Team -->
                                                <div class="flex flex-col items-center">
                                                    <div
                                                        class="w-16 h-16 rounded-full flex items-center justify-center mb-2">
                                                        <img [src]="upcomingMatch.isHome ? teamLogoUrl : (upcomingMatch.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                                            alt="Home Team Logo" class="w-full h-full object-contain" />
                                                    </div>
                                                    <span class="text-sm font-semibold text-center">{{
                                                        upcomingMatch.homeTeam }}</span>
                                                </div>
                                                <!-- VS -->
                                                <div class="text-xl font-bold mx-4">VS</div>
                                                <!-- Away Team -->
                                                <div class="flex flex-col items-center">
                                                    <div
                                                        class="w-16 h-16 rounded-full flex items-center justify-center mb-2">
                                                        <img [src]="upcomingMatch.isHome ? (upcomingMatch.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                                            alt="Away Team Logo" class="w-full h-full object-contain" />
                                                    </div>
                                                    <span class="text-sm font-semibold text-center">{{
                                                        upcomingMatch.awayTeam }}</span>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-4 gap-2 mb-4">
                                        <div class="text-center">
                                            <div class="text-3xl font-bold text-primary-400">{{
                                                formatCountdownNumber(countdown.days) }}</div>
                                            <div class="text-xs text-gray-400">JOURS</div>
                                        </div>
                                        <div class="text-center">
                                            <div class="text-3xl font-bold text-primary-400">{{
                                                formatCountdownNumber(countdown.hours) }}</div>
                                            <div class="text-xs text-gray-400">HEURES</div>
                                        </div>
                                        <div class="text-center">
                                            <div class="text-3xl font-bold text-primary-400">{{
                                                formatCountdownNumber(countdown.minutes) }}</div>
                                            <div class="text-xs text-gray-400">MIN</div>
                                        </div>
                                        <div class="text-center">
                                            <div class="text-3xl font-bold text-primary-400">{{
                                                formatCountdownNumber(countdown.seconds) }}</div>
                                            <div class="text-xs text-gray-400">SEC</div>
                                        </div>
                                    </div>
                                    <div class="text-center text-gray-400 text-sm">
                                        📍 {{ upcomingMatch.location || 'À définir' }}
                                    </div>
                                </div>
                                <ng-template #noMatch>
                                    <div class="text-center text-gray-400">Aucun match à venir</div>
                                </ng-template>
                            </div>

                            <!-- Players -->
                            <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                                <h2 class="text-2xl font-bold mb-6 text-primary-400">JOUEURS</h2>
                                <div class="space-y-3 max-h-96 overflow-y-auto">
                                    <div *ngFor="let player of players"
                                        class="flex items-center justify-between p-3 bg-black/30 rounded-lg hover:bg-black/50 transition-colors">
                                        <div class="flex items-center space-x-3">
                                            <div
                                                class="w-10 h-10 bg-gradient-to-br from-primary-400 to-primary-900 rounded-full flex items-center justify-center text-black font-bold text-sm">
                                                {{ getPlayerInitials(player.name) }}
                                            </div>
                                            <div>
                                                <p class="font-semibold">{{ formatPlayerName(player.name) }}</p>
                                                <p class="text-gray-400 text-sm">{{ player.position }}</p>
                                            </div>
                                        </div>
                                        <div class="w-3 h-3 bg-green-500 rounded-full" title="Actif"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- Past Matches Section (Desktop) -->
                    <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 mt-8">
                        <h2 class="text-2xl font-bold mb-4 text-primary-400">MATCHS PASSÉS</h2>
                        <div class="space-y-4">
                            <ng-container *ngIf="pastMatches.length; else noPastMatches">
                                <div *ngFor="let match of pastMatches"
                                    class="flex flex-col p-3 border-b border-gray-600 last:border-b-0">
                                    <div class="flex justify-between items-center w-full">
                                        <!-- Home Team (Left) -->
                                        <div class="flex items-center gap-3 w-2/5 justify-end">
                                            <span class="font-medium text-white truncate text-sm">
                                                {{ match.homeTeam }}
                                            </span>
                                            <img [src]="match.isHome ? teamLogoUrl : (match.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                                alt="Home Team Logo" class="w-10 h-10 rounded-full" />
                                        </div>
                                        <!-- Score and Status (Center) -->
                                        <div class="flex flex-col items-center w-1/5">
                                            <div class="text-white font-bold text-sm">
                                                {{ formatMatchScore(match) }}
                                            </div>
                                        </div>
                                        <!-- Away Team (Right) -->
                                        <div class="flex items-center gap-3 w-2/5">
                                            <img [src]="match.isHome ? (match.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                                alt="Away Team Logo" class="w-10 h-10 rounded-full" />
                                            <span class="font-medium text-white truncate text-sm">
                                                {{ match.awayTeam }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="flex justify-center items-center mt-2">
                                        @let label = getMatchStatusLabel(match.status);
                                        @if (label) {
                                        @switch (sport) {
                                        @case ('basketball') {
                                        <span [class.text-green-400]="match.status === 'win'"
                                            [class.text-red-400]="match.status === 'loss'"
                                            [class.text-gray-400]="match.status === 'forfeit'">
                                            {{ label }}
                                        </span>
                                        }
                                        @default {
                                        <span [class.text-green-400]="match.status === 'win'"
                                            [class.text-yellow-400]="match.status === 'draw'"
                                            [class.text-red-400]="match.status === 'loss'"
                                            [class.text-gray-400]="match.status === 'forfeit'">
                                            {{ label }}
                                        </span>
                                        }
                                        }
                                        }
                                    </div>

                                    <div class="flex justify-center items-center mt-2">
                                        <div class="text-sm text-gray-400">
                                            {{ match.date | date:'EEEE, dd MMMM':'fr' }}
                                        </div>
                                    </div>
                                    <div class="flex justify-center items-center mt-2">
                                        <button type="button" mat-flat-button color="primary"
                                            class="text-white flex items-center gap-1 px-4 py-2"(touchstart)="onGoToMatchDetail(match.id)"
                                            (click)="onGoToMatchDetail(match.id)">
                                            <mat-icon class="text-base">summarize</mat-icon>
                                            Voir le résumé
                                        </button>
                                    </div>


                                </div>
                            </ng-container>
                            <ng-template #noPastMatches>
                                <div class="text-gray-400 text-center py-4">
                                    Aucun match passé récent
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MOBILE VERSION - Visible only on mobile -->
        <div class="lg:hidden ">

            <!-- Mobile Header -->
            <div class="relative bg-cover bg-center bg-no-repeat !h-[50vh]"
                [ngStyle]="{'background-image': team.teamInfo.banner_url ? 'url(' + team.teamInfo.banner_url + ')' : 'url(assets/images/team/bck1.jpg)'}">
                <div class="absolute inset-0 bg-black opacity-70"></div>
                <div class="relative z-10 h-full flex flex-col justify-between p-4">
                    <!-- Top Section - Team Info -->
                    <div class="text-center pt-8">
                        <h1 class="text-3xl font-extrabold text-white mb-2 drop-shadow-lg">
                            {{ team.teamInfo.name || '' }}
                        </h1>
                        <p class="text-lg text-primary-400 font-semibold drop-shadow-lg">
                            {{ team.teamInfo.description || 'Équipe Filles U16' }}
                        </p>
                        <!-- Team Logo -->
                        <div class="w-24 h-24 mx-auto mt-6 rounded-full overflow-hidden border-4 border-primary-400">
                            <app-logo></app-logo>
                        </div>
                        <!-- Contact Info -->
                        <div class="mt-6 space-y-2 text-sm">
                            <p class="text-gray-300">
                                CONTACT: <span class="text-primary-400">{{ team.teamInfo.email ||
                                    'info@ecoclubsports.com' }}</span>
                            </p>

                            <div class="flex items-center justify-center space-x-2 text-gray-300">
                                <svg class="4 h-4" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.003 5.884l.94-2.828A1 1 0 013.89 2h2.517a1 1 0 01.949.684l1.077 3.23a1 1 0 01-.21.987L6.71 8.84a11.042 11.042 0 005.44 5.44l1.94-1.413a1 1 0 01.987-.21l3.23 1.077a1 1 0 01.684.949v2.517a1 1 0 01-.73.957l-2.828.94a2 2 0 01-1.848-.267 17.013 17.013 0 01-7.592-7.592 2 2 0 01-.267-1.848z" />
                                </svg>

                                <p class="text-gray-300 ml-1">{{ team.teamInfo.phone || '+33 000 00000' }}</p>

                            </div>
                            <div class="flex items-center justify-center space-x-2 text-gray-300">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>{{ team.teamInfo.location || 'Paris, France' }}</span>
                            </div>
                            <div class="flex items-center justify-center space-x-2 text-gray-300">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>Saison {{ team.teamInfo.season || '2024-2025' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile Content Sections -->
            <div class="px-4 py-6 space-y-6">
                <!-- Middle Section - Match à venir -->
                <div class="text-center">
                    <h2 class="text-xl font-bold text-primary-400 mb-4">Match à venir</h2>
                    <!-- Upcoming matches carousel -->
                    <div class="flex space-x-4 overflow-x-auto pb-4 px-2">
                        <div class="flex-shrink-0 bg-primary-400 rounded-xl p-4 text-black min-w-[280px] shadow-lg"
                            *ngFor="let match of upcomingEvents">
                            <div class="text-center">
                                <h3 class="font-bold mb-3 text-xl italic">{{ getEventTypeLabel(match.type) }}</h3>
                                <!-- Teams vs Section -->
                                <div class="flex items-center justify-between mb-4">
                                    <ng-container
                                        *ngIf="match.type === 'ENTRAINEMENT' || match.type === 'EVENEMENT'; else matchVsMobile">
                                        <!-- Single Team Logo for Training/Event -->
                                        <div class="flex flex-col items-center w-full">
                                            <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                                <img [src]="teamLogoUrl" alt="Team Logo"
                                                    class="w-full h-full object-contain">
                                            </div>
                                            <span class="text-xs font-semibold text-center">
                                                {{ team.teamInfo.name }}
                                            </span>
                                        </div>
                                    </ng-container>
                                    <ng-template #matchVsMobile>
                                        <!-- Home Team -->
                                        <div class="flex flex-col items-center">
                                            <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                                <img [src]="match.isHome ? teamLogoUrl : (match.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                                    alt="Home Team Logo" class="w-full h-full object-contain">
                                            </div>
                                            <span class="text-xs font-semibold text-center">{{ match.homeTeam }}</span>
                                        </div>
                                        <!-- VS -->
                                        <div class="text-xl font-bold mx-3">VS</div>
                                        <!-- Away Team -->
                                        <div class="flex flex-col items-center">
                                            <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                                <img [src]="match.isHome ? (match.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                                    alt="Away Team Logo" class="w-full h-full object-contain" />
                                            </div>
                                            <span class="text-xs font-semibold text-center">{{ match.awayTeam }}</span>
                                        </div>
                                    </ng-template>
                                </div>
                                <!-- Match Details -->
                                <div class="space-y-1 text-sm">
                                    <div class="font-semibold">
                                        {{ match.date | date:'EEEE, dd MMMM':'fr' }}
                                    </div>

                                    <div class="text-gray-700">
                                        📍 {{ match.location || 'À définir' }}
                                    </div>
                                    @if(match.type !== 'ENTRAINEMENT' && match.type !== 'EVENEMENT') {
                                    <div class="flex w-full items-center justify-center my-2">
                                        <button type="button" (touchstart)="onGoToMatchDetail(match.id)" (click)="onGoToMatchDetail(match.id)" mat-flat-button color="primary">
                                            {{ "ADVERTISING.view_details" | transloco }}
                                        </button>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bottom Section - Next Match Countdown -->
                <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700"
                    *ngIf="upcomingMatch; else noMatchMobile">
                    <div class="text-center mb-4">
                        <h3 class="text-primary-400 font-bold text-lg mb-2">PROCHAIN MATCH</h3>
                        <p class="text-gray-300 text-sm mb-2">{{ upcomingMatch.date | date:'EEEE, dd MMMM':'fr' }}</p>
                        <div class="flex items-center justify-center mb-4">
                            <ng-container
                                *ngIf="upcomingMatch.type === 'ENTRAINEMENT' || upcomingMatch.type === 'EVENEMENT'; else matchVsMobile">
                                <!-- Single Team Logo for Training/Event -->
                                <div class="flex flex-col items-center w-full">
                                    <h3 class="font-bold mb-2 text-lg" *ngIf="upcomingMatch.type === 'ENTRAINEMENT'">{{
                                        getEventTypeLabel(upcomingMatch.type) }}</h3>

                                    <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                        <img [src]="teamLogoUrl" alt="Team Logo" class="w-full h-full object-contain" />
                                    </div>
                                    <span class="text-xs font-semibold text-center">{{ team.teamInfo.name }}</span>
                                </div>
                            </ng-container>
                            <ng-template #matchVsMobile>
                                <!-- Home Team -->
                                <div class="flex flex-col items-center">
                                    <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                        <img [src]="upcomingMatch.isHome ? teamLogoUrl : (upcomingMatch.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                            alt="Home Team Logo" class="w-full h-full object-contain" />
                                    </div>
                                    <span class="text-xs font-semibold text-center">{{ upcomingMatch.homeTeam }}</span>
                                </div>
                                <!-- VS -->
                                <div class="text-xl font-bold mx-3">VS</div>
                                <!-- Away Team -->
                                <div class="flex flex-col items-center">
                                    <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2">
                                        <img [src]="upcomingMatch.isHome ? (upcomingMatch.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                            alt="Away Team Logo" class="w-full h-full object-contain" />
                                    </div>
                                    <span class="text-xs font-semibold text-center">{{ upcomingMatch.awayTeam }}</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <!-- Countdown Timer -->
                    <div class="grid grid-cols-4 gap-2 mb-4">
                        <div class="text-center">
                            <div class="text-2xl font-bold text-primary-400">{{ formatCountdownNumber(countdown.days) }}
                            </div>
                            <div class="text-xs text-gray-400">Jours</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold text-primary-400">{{ formatCountdownNumber(countdown.hours)
                                }}</div>
                            <div class="text-xs text-gray-400">Heures</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold text-primary-400">{{ formatCountdownNumber(countdown.minutes)
                                }}</div>
                            <div class="text-xs text-gray-400">Minutes</div>
                        </div>
                        <div class="text-center">
                            <div class="text-2xl font-bold text-primary-400">{{ formatCountdownNumber(countdown.seconds)
                                }}</div>
                            <div class="text-xs text-gray-400">Secondes</div>
                        </div>
                    </div>
                    <div class="text-center text-gray-400 text-sm">
                        📍 {{ upcomingMatch.location || 'À définir' }}
                    </div>
                </div>
                <ng-template #noMatchMobile>
                    <div class="text-center text-gray-400">Aucun match à venir</div>
                </ng-template>
                <!-- Coach Section -->
                <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 relative">
                    <h2 class="text-xl font-bold mb-4 text-primary-400 text-center">COACH</h2>
                    <div class="relative">
                        <!-- Left Arrow -->
                        <button (click)="previousCoach()"
                            class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-primary-400 text-black rounded-full w-8 h-8 flex items-center justify-center hover:bg-primary-500 transition-colors"
                            aria-label="Previous Coach">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <!-- Coach Content -->
                        <div class="text-center mb-4">
                            <div
                                class="w-20 h-20 bg-gradient-to-br from-primary-400 to-orange-500 rounded-full flex items-center justify-center text-black font-bold text-xl mx-auto mb-3">
                                {{ getPlayerInitials(getCurrentCoach().name) }}
                            </div>
                            <h3 class="text-xl font-bold text-white">{{ getCurrentCoach().name }}</h3>
                            <p class="text-primary-400 font-medium">{{ getCurrentCoach().title }}</p>
                        </div>
                        <!-- Right Arrow -->
                        <button (click)="nextCoach()"
                            class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-primary-400 text-black rounded-full w-8 h-8 flex items-center justify-center hover:bg-primary-500 transition-colors"
                            aria-label="Next Coach">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                        <!-- Coach Image -->
                        <div class="flex justify-center mb-4">
                            <img [src]="getCoachLogoUrl(getCurrentCoach())" alt="Coach Logo"
                                class="w-32 h-24 object-contain opacity-80" />
                        </div>
                        <!-- Dots for Coach Navigation -->
                        <div class="flex justify-center space-x-2 mt-2">
                            <div *ngFor="let coach of coaches; let i = index"
                                class="w-2 h-2 rounded-full transition-all duration-300"
                                [ngClass]="i === currentCoachIndex ? 'bg-primary-400' : 'bg-gray-500'"
                                (click)="goToCoach(i)">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Players Section -->
                <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                    <h2 class="text-xl font-bold mb-4 text-primary-400 text-center">JOUEURS</h2>
                    <div class="space-y-3 max-h-64 overflow-y-auto">
                        <div *ngFor="let player of players"
                            class="flex items-center justify-between p-3 bg-black/30 rounded-lg">
                            <div class="flex items-center space-x-3">
                                <div
                                    class="w-8 h-8 bg-gradient-to-br from-primary-400 to-gray-500 rounded-full flex items-center justify-center text-black font-bold text-xs">
                                    {{ getPlayerInitials(player.name) }}
                                </div>
                                <div>
                                    <p class="font-semibold text-sm">{{ formatPlayerName(player.name) }}</p>
                                    <p class="text-gray-400 text-xs">{{ player.position }}</p>
                                </div>
                            </div>
                            <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                        </div>
                    </div>
                </div>
                <!-- Terrain Section (Mobile) -->
                <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                    <h2 class="text-xl font-bold mb-4 text-primary-400 text-center">COMPOSITION</h2>

                    <!-- Affichage du composant lineup si disponible -->
                    <div *ngIf="lastMatchWithLineup?.lineup; else defaultTerrainMobile">
                        <app-lineup [match]="lastMatchWithLineup" [lastValidLineup]="lastMatchWithLineup.lineup"
                            [readOnlyMode]="true">
                        </app-lineup>
                    </div>

                    <!-- Terrain par défaut sans joueurs -->
                    <ng-template #defaultTerrainMobile>
                        <app-lineup [match]="createEmptyMatch()" [readOnlyMode]="true">
                        </app-lineup>
                    </ng-template>
                </div>
                <div class="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
                    <h2 class="text-xl font-bold mb-4 text-primary-400 text-center">MATCHS PASSÉS</h2>
                    <div class="space-y-4">
                        <ng-container *ngIf="pastMatches.length; else noPastMatches">
                            <div *ngFor="let match of pastMatches"
                                class="flex flex-col p-3 border-b border-gray-600 last:border-b-0">
                                <div class="flex justify-between items-center w-full">
                                    <!-- Home Team (Left) -->
                                    <div class="flex items-center gap-3 w-2/5 justify-end">
                                        <span class="font-medium text-white truncate text-sm">
                                            {{ match.homeTeam }}
                                        </span>
                                        <img [src]="match.isHome ? teamLogoUrl : (match.opponentLogo_url || 'assets/images/fall-back/badge.png')"
                                            alt="Home Team Logo" class="w-10 h-10 rounded-full" />
                                    </div>
                                    <!-- Score and Status (Center) -->
                                    <div class="flex flex-col items-center w-1/5">
                                        <div class="text-white font-bold text-sm">
                                            {{ formatMatchScore(match) }}
                                        </div>
                                    </div>
                                    <!-- Away Team (Right) -->
                                    <div class="flex items-center gap-3 w-2/5">
                                        <img [src]="match.isHome ? (match.opponentLogo_url || 'assets/images/fall-back/badge.png') : teamLogoUrl"
                                            alt="Away Team Logo" class="w-10 h-10 rounded-full" />
                                        <span class="font-medium text-white truncate text-sm">
                                            {{ match.awayTeam }}
                                        </span>
                                    </div>
                                </div>
                                <div class="flex justify-center items-center mt-2">
                                    <span *ngIf="getMatchStatusLabel(match.status)" [ngClass]="{
        'text-green-400': match.status === 'win',
        'text-yellow-400': match.status === 'draw',
        'text-red-400': match.status === 'loss',
        'text-gray-400': match.status === 'forfeit'}">
                                        {{ getMatchStatusLabel(match.status) }}
                                    </span>
                                </div>
                                <!-- Match Date -->
                                <div class="flex justify-center items-center mt-2">
                                    <div class="text-sm text-gray-400">
                                        {{ match.date | date:'EEEE, dd MMMM':'fr' }}
                                    </div>
                                </div>
                                <div class="flex justify-center items-center mt-2">
                                    <button type="button" mat-flat-button color="primary"
                                        class="text-white flex items-center gap-1 px-4 py-2 "(touchstart)="onGoToMatchDetail(match.id)" 
                                        (click)="onGoToMatchDetail(match.id)">
                                        <mat-icon class="text-base">summarize</mat-icon>
                                        Voir le résumé
                                    </button>
                                </div>

                            </div>
                        </ng-container>
                        <ng-template #noPastMatches>
                            <div class="text-gray-400 text-center py-4">
                                Aucun match passé récent
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>